import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ChatPreviewWrapper__Wrapper",
  componentId: "h4gce0-0"
})(["width:100%;height:100%;display:flex;justify-content:center;align-items:center;& > div{transform-origin:center;}"]);
export default function ChatPreviewWrapper({
  children
}) {
  const [size, setSize] = useState('default');
  const wrapperRef = useRef(null);
  useEffect(() => {
    const handleResize = () => {
      if (wrapperRef.current) {
        if (wrapperRef.current.clientWidth < 282 || wrapperRef.current.clientHeight < 400) {
          setSize('extra-small');
        } else if (wrapperRef.current.clientWidth < 376 || wrapperRef.current.clientHeight < 530) {
          setSize('small');
        } else {
          setSize('default');
        }
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return /*#__PURE__*/_jsx(Wrapper, {
    ref: wrapperRef,
    children: children(size)
  });
}